import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import jnylogo from "./jnylogo.svg";

export default function Navbar() {
  let arr = [true, false, false, false, false, false];
  const [style, setStyle] = useState(arr);
  const [dropDown, setDropDown] = useState(true);
  const [text, setText] = useState("");

  const selected = (props) => {
    let newArr = [...arr];
    for (let i = 0; i < newArr.length; i++) {
      newArr[i] = false;
    }
    newArr[props] = true;
    setStyle(newArr);
  };

  const setSelectedText = (txt) => {
    setText(txt);
    setDropDown(true);
  };

  return (
    <div>
      <div className="2xl:container 2xl:mx-auto">
        <div className="lg:flex flex-col bg-black py-3 px-7  ">
          <div className="flex flex-col ">
            <nav>
              {/* For medium and plus sized devices */}
              <div className="flex align-items-center justify-center">
                <ul className="nl mb-0 flex align-items-center justify-center md:space-x-11">
                  
                  <Link className="link" to="/">
                    <li
                      onClick={() => selected(0)}
                      className={`${
                        style[0] ? "text-white bg-gray-600" : "text-white"
                      } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 cursor-pointer px-3 py-2.5 font-normal text-xs leading-3 rounded`}
                    >
                      HOME
                    </li>
                  </Link>
                  <Link
                    className="link"
                    to="Ourwork"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <li
                      onClick={() => selected(1)}
                      className={`${
                        style[1] ? "text-white bg-gray-600" : "text-white"
                      } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 cursor-pointer px-3 py-2.5 font-normal text-xs leading-3 rounded`}
                    >
                      OUR WORK
                    </li>
                  </Link>
                  <li>
                    <img
                      src={jnylogo}
                      alt="SVG logo"
                      width={74}
                      height={74}
                      viewBox="0 0 34 34"
                      fill="none"
                    />
                  </li>
                  <Link
                    className="link"
                    to="technolo"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <li
                      onClick={() => selected(2)}
                      className={`${
                        style[2] ? "text-white bg-gray-600" : "text-white"
                      } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 cursor-pointer px-3 py-2.5 font-normal text-xs leading-3 rounded`}
                    >
                      TECHNOLOGIES
                    </li>
                  </Link>
                  
                  {/* <Link className="link" to="Aboutus">
                    <li
                      onClick={() => selected(3)}
                      className={`${
                        style[3] ? "text-white bg-gray-600" : "text-white  "
                      } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 cursor-pointer px-3 py-2.5 font-normal text-xs leading-3 rounded`}
                    >
                      ABOUT US
                    </li>
                  </Link> */}
                
                  <Link
                    className="link"
                    to="Contactus"
                    spy={true}
                    smooth={false}
                    offset={-90}
                    duration={900}
                  >
                    <li
                      onClick={() => selected(4)}
                      className={`${
                        style[4] ? "text-white bg-gray-600" : "text-white"
                      } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 cursor-pointer px-3 py-2.5 font-normal text-xs leading-3 rounded`}
                    >
                      CONTACT US
                    </li>
                  </Link>
                  {/* Add the rest of your list items here */}
                </ul>
              </div>
            </nav>
          </div>
          {/* for smaller devcies */}
          <div className="content block md:hidden w-full mt-2 ">
            <div
              onClick={() => setDropDown(!dropDown)}
              className="cursor-pointer px-4 py-3 text-white bg-green-500 rounded flex justify-between items-center w-full"
            >
              <div className="flex space-x-2">
                <span
                  id="s1"
                  className={`${
                    text.length !== 0 ? "" : "hidden"
                  } font-semibold text-sm leading-3`}
                >
                  Selected:{" "}
                </span>
                <p
                  id="textClicked"
                  className="font-normal text-sm leading-3 focus:outline-none hover:bg-gray-800 duration-100 cursor-pointer mb-0 "
                >
                  {text ? text : "Menu"}
                </p>
              </div>
              <svg
                id="ArrowSVG"
                className={`${
                  dropDown ? "" : "rotate-180"
                } transform duration-100`}
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className=" relative">
              <ul
                id="list"
                className={`${
                  dropDown ? "hidden" : "block"
                } font-normal text-base leading-4 top-2 animate-typewriter  w-full rounded shadow-md bg-gray-900`}
              >
                <li
                  onClick={() => setSelectedText("INDUSTRIES")}
                  className=" bg-gray-600 px-4 py-3 text-gray-600 border border-gray-50 focus:outline-none focus:bg-gray-100 hover:bg-gray-100 duration-100 cursor-pointer text-xs leading-3 font-normal"
                >
                  INDUSTRIES
                </li>
                <li
                  onClick={() => setSelectedText("OUR WORK")}
                  className="px-4 py-3 text-gray-600 bg-gray-50 border border-gray-50 focus:outline-none focus:bg-gray-100 hover:bg-gray-100 duration-100 cursor-pointer text-xs leading-3 font-normal"
                >
                  OUR WORK
                </li>
                <Link
                  to="techdiv"
                  spy={true}
                  smooth={false}
                  offset={-90}
                  duration={900}
                >
                  <li
                    onClick={() => setSelectedText("TECHNOLOGIES")}
                    className="px-4 py-3 text-gray-600 bg-gray-50 border border-gray-50 focus:outline-none focus:bg-gray-100 hover:bg-gray-100 duration-100 cursor-pointer text-xs leading-3 font-normal"
                  >
                    TECHNOLOGIES
                  </li>
                </Link>
                <li
                  onClick={() => setSelectedText("ABOUT US")}
                  className="px-4 py-3 text-gray-600 bg-gray-50 border border-gray-50 focus:outline-none focus:bg-gray-100 hover:bg-gray-100 duration-100 cursor-pointer text-xs leading-3 font-normal"
                >
                  ABOUT US
                </li>
                <Link
                  to="contact"
                  spy={true}
                  smooth={false}
                  offset={-90}
                  duration={900}
                >
                  <li
                    onClick={() => setSelectedText("CONTACT US")}
                    className="px-4 py-3 text-gray-600 bg-gray-50 border border-gray-50 focus:outline-none focus:bg-gray-100 hover:bg-gray-100 duration-100 cursor-pointer text-xs leading-3 font-normal"
                  >
                    CONTACT US
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
